import type { ChromeCopy } from './types'

// Assamese. Exported as `asm` because `as` is a reserved word in TypeScript.
export const asm: ChromeCopy = {
  appName: 'সমঝো',
  tagline: 'কাগজখন বুজক। ইয়াৰ পিছত কি কৰিব, জানি লওক।',
  savedTitle: 'ছেভ কৰা কাগজ',
  upcomingTitle: 'আগন্তুক শেষ তাৰিখবোৰ',
  markDone: 'কাম হৈ গ\'ল',
  doneLabel: 'হৈ গ\'ল',
  deadlineCheckIn: '{n}খন ছেভ কৰা কাগজৰ শেষ তাৰিখ ওচৰ চাপিছে। কাম হ\'ল নে?',
  savedHint: 'এইবোৰ কেৱল এই ফোনতহে আছে। কাগজৰ ফটো আৰু গোটেই লিখা কেতিয়াও ছেভ নহয় — কেৱল দৰকাৰী তথ্যহে।',
  emptySaved: 'এতিয়ালৈকে কোনো কাগজ ছেভ কৰা নাই।',
  clearAll: 'সকলো মচি পেলাওক',
  deleteItem: 'মচক',
  aboutTitle: 'গোপনীয়তা আৰু দৰকাৰী তথ্য',
  privacyPoints: [
    'আপোনাৰ কাগজৰ ফটো আৰু তাত লিখা কথাবোৰ এই ফোনতে পঢ়া হয় আৰু বুজাই দিয়া হয়। ফটোখন ক’তো আপলোড কৰা নহয়।',
    'আপুনি "ছেভ কৰক" নিটিপালৈকে একো ছেভ নহয়। "নতুন কাগজ" টিপিলেই আগৰ কাগজখন স্ক্ৰীন আৰু মেমৰিৰ পৰা আঁতৰি যায়।',
    'ছেভ কৰিলে কেৱল দৰকাৰী তথ্য (তাৰিখ, টকাৰ পৰিমাণ, নম্বৰ) ৰখা হয়, কেৱল এই ফোনতে — ফটো বা গোটেই লিখা নহয়। আপুনি যিকোনো সময়তে এইবোৰ মচি পেলাব পাৰে।',
    'ইণ্টাৰনেট কেৱল তিনিটা কামৰ বাবে লাগে: প্ৰথমবাৰ পঢ়াৰ টুলটো আৰু মাতবোৰ (সমঝোৰ নিজৰ ছাইটৰ পৰা) ডাউনলোড কৰিবলৈ, আৰু — আপুনি বিচাৰিলেহে — কাগজখনৰ ইংৰাজী শাৰীবোৰ অনুবাদ কৰিবলৈ। অনুবাদৰ বাবে পঠোৱা শাৰীবোৰ ছেভ কৰা নহয়, আৰু আধাৰ আৰু ফোনৰ দৰে নম্বৰবোৰ আগতেই আঁতৰাই দিয়া হয়। তৃতীয়তে — আপুনি প্ৰশ্ন সুধিলেহে: উত্তৰ লিখিবলৈ কাগজৰ লিখা আৰু আপোনাৰ প্ৰশ্ন সমঝোৰ চাৰ্ভাৰ আৰু এটা AI সেৱালৈ (Groq) যায়, আধাৰ, পেন, ফোন আৰু ইমেইল আগতে আঁতৰাই; কেৱল চৰকাৰী ৱেবছাইট চোৱা হয়, আৰু একো ছেভ কৰা নহয়। যিবোৰ শাৰী ইংৰাজীত নহয়, সেইবোৰ এটা AI সেৱাই (Groq) অনুবাদ কৰে।',
    'সমঝোত কোনো বিজ্ঞাপন নাই। আমি কেৱল কিমানজন মানুহে এপটো খোলে সেইটোহে গণনা কৰোঁ (Cloudflare Web Analytics, কোনো কুকি নোহোৱাকৈ)। আপোনাৰ কাগজৰ একোৱেই তাত নাথাকে, আৰু কাগজত লিখা কথা কেতিয়াও লগ কৰা নহয়।'
  ],
  disclaimerTitle: 'এইটো চৰকাৰী বা আইনী পৰামৰ্শ নহয়',
  disclaimer: 'সমঝো এটা স্বাধীন সহায়ক টুল, চৰকাৰী ৱেবছাইট নহয়। ই আপোনাৰ কাগজখন সহজকৈ বুজাই দিয়ে, কিন্তু ইয়াৰ ব্যাখ্যা চৰকাৰী বা আইনী ব্যাখ্যা নহয়। দৰকাৰী কথাবোৰ সদায় মূল কাগজখন বা কাগজখন দিয়া কাৰ্যালয়ৰ লগত মিলাই লওক।',
  contactTitle: 'কিবা সমস্যা হৈছে নেকি?',
  contact: 'কিবা সমস্যা হ’লে আমাক ইয়াত যোগাযোগ কৰক:',
  freeTitle: 'সম্পূৰ্ণ বিনামূলীয়া',
  free: 'সমঝো ওপেন-ছ’ৰ্চ টুলেৰে চলে: পঢ়াৰ বাবে Tesseract, আৰু শুনাবলৈ আপোনাৰ ফোনৰ নিজৰ মাত বা Meta-ৰ ওপেন MMS মাত (CC BY-NC 4.0)। কোনো একাউণ্ট নালাগে, কোনো টকা নালাগে।',
  shareApp: 'WhatsApp-ত শ্বেয়াৰ কৰক',
  installApp: 'এপটো ফোনত যোগ কৰক',
  offline: 'আপুনি অফলাইন আছে',
  offlineHint: 'আগতে সমঝো ব্যৱহাৰ কৰা হৈছে যদি, ইণ্টাৰনেট নোহোৱাকৈও কাগজ পঢ়িব পাৰি।',
  shareAppMessage: 'চৰকাৰী কাগজ সহজ ভাষাত বুজিবলৈ আৰু শুনিবলৈ SAMJHO ব্যৱহাৰ কৰক (বিনামূলীয়া):\nhttps://samjho.pages.dev'
}
